export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 8a1 1 0 011 1v11a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h18zM6 19h1.23A2 2 0 006 18.065V19zm3.468-9A4 4 0 016 13.468v2.563c1.64.205 2.97 1.4 3.374 2.969h9.158A4 4 0 0122 15.531v-2.563A4.003 4.003 0 0118.626 10H9.468zM22 17.565A2 2 0 0020.565 19H22v-1.435zM6 11.434A1.998 1.998 0 007.435 10H6v1.434zM20.77 10a2 2 0 001.23.934V10h-1.23z\" fill=\"#7B61FF\"/><path d=\"M19 6H2v10H0V5a1 1 0 011-1h18v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};